export type StepType = 'browse' | 'buy' | 'watch' | 'withdraw'

export type ProcessStep = {
  id: StepType
  title: string
  number: string
  description: string
}

/**
 * Single source of truth for the four "How it works" steps.
 * Used by the homepage scroll sequence and by the /how-it-works page so the
 * wording can never drift between the two.
 */
export const PROCESS_STEPS: readonly ProcessStep[] = [
  {
    id: 'browse',
    title: 'Browse projects',
    number: '1',
    description:
      'Discover vetted development projects across Nigeria. See location, valuation, expected returns, and developer track record.',
  },
  {
    id: 'buy',
    title: 'Buy a stake',
    number: '2',
    description:
      "Pick how much you want to invest. Your stake gives you a proportional share of the project's returns. No minimum net worth. No paperwork.",
  },
  {
    id: 'watch',
    title: 'Watch it grow',
    number: '3',
    description: 'Track your investment as the project develops and increases in value.',
  },
  {
    id: 'withdraw',
    title: 'Withdraw returns',
    number: '4',
    description:
      'Receive your share of profits when the project sells or sell your tokens early on secondary market.',
  },
]
